// extracted by mini-css-extract-plugin
export default {"tableHeader":"ExpandableTable_tableHeader__7u+tB","registros":"ExpandableTable_registros__xUOf9","expandButton":"ExpandableTable_expandButton__5Ajnv"};